module.exports = __webpack_public_path__ + "static/media/manufacturing-macrovector-02-c 17.b22bb825.png";